import { render, staticRenderFns } from "./setPassword.vue?vue&type=template&id=42a2dc9a&scoped=true"
import script from "./setPassword.vue?vue&type=script&lang=js"
export * from "./setPassword.vue?vue&type=script&lang=js"
import style0 from "./setPassword.vue?vue&type=style&index=0&id=42a2dc9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a2dc9a",
  null
  
)

export default component.exports